export default __webpack_public_path__ + "static/img-art-pandas-profiling-2-530f7bbe1a286fec0a7f07c826c706df.png";